import { Files, FolderOpen, Plus, Upload } from "lucide-react";
import { FranklinIcon } from "@/components/ui/franklin-icon";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { COMPOSER_ACTION_CLASS } from "@/components/chat/thread/ComposerShell";
import { useLanguage } from "@/lib/i18n/LanguageContext";

interface AddFileMenuProps {
  onUploadClick?: () => void;
  onBrowseProjectsClick?: () => void;
  onWorkInProjectClick?: () => void;
  onOpenFilesPanel?: () => void;
}

function AddFileMenuItems({
  onUploadClick,
  onBrowseProjectsClick,
  onWorkInProjectClick,
  onOpenFilesPanel,
}: AddFileMenuProps) {
  const { t } = useLanguage();
  return (
    <>
      {onUploadClick && (
        <DropdownMenuItem onSelect={() => setTimeout(onUploadClick, 0)}>
          <Upload className="mr-2 h-3.5 w-3.5 shrink-0" />
          {t.documents.chatSidebar.attachMenu.upload}
        </DropdownMenuItem>
      )}
      {onBrowseProjectsClick && (
        <DropdownMenuItem onSelect={onBrowseProjectsClick}>
          <FranklinIcon className="mr-2 h-3.5 w-3.5 shrink-0" />
          {t.documents.chatSidebar.attachMenu.addFromFranklin}
        </DropdownMenuItem>
      )}
      {onOpenFilesPanel && (
        <DropdownMenuItem onSelect={onOpenFilesPanel}>
          <Files className="mr-2 h-3.5 w-3.5 shrink-0" />
          {t.documents.chatSidebar.attachMenu.openFiles}
        </DropdownMenuItem>
      )}
      {onWorkInProjectClick && (
        <DropdownMenuItem onSelect={onWorkInProjectClick}>
          <FolderOpen className="mr-2 h-3.5 w-3.5 shrink-0" />
          {t.documents.chatSidebar.attachMenu.workInProject}
        </DropdownMenuItem>
      )}
    </>
  );
}

export function AddFileMenu(props: AddFileMenuProps) {
  const { t } = useLanguage();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={COMPOSER_ACTION_CLASS}
          aria-label={t.documents.chatSidebar.addFile}
        >
          <Plus className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" side="top" className="w-52">
        <AddFileMenuItems {...props} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
